module.exports = __webpack_public_path__ + "assets/img/ContainerCloud.49b1fb27.png";